import { render, staticRenderFns } from "./subReg.vue?vue&type=template&id=b4cb5e04&scoped=true"
import script from "./subReg.vue?vue&type=script&lang=js"
export * from "./subReg.vue?vue&type=script&lang=js"
import style0 from "./subReg.vue?vue&type=style&index=0&id=b4cb5e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cb5e04",
  null
  
)

export default component.exports